// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// const ForgotPassword = () => {
//   const [email, setEmail] = useState('');
//   const [message, setMessage] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const [isSuccess, setIsSuccess] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setMessage('');
    
//     try {
//       // Get API URL from environment or use default
//       const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      
//       const response = await fetch(`${apiUrl}/auth/reset-password-request`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email }),
//       });
      
//       const data = await response.json();
      
//       if (response.ok) {
//         setIsSuccess(true);
//         setMessage(data.message || 'If an account exists with this email, a reset link will be sent. Please check your inbox and spam folder.');
//       } else {
//         setMessage(data.message || 'An error occurred. Please try again.');
//       }
//     } catch (error) {
//       setMessage('An error occurred. Please try again.');
//     }
    
//     setIsLoading(false);
//   };

//   return (
//     <div style={{ maxWidth: '400px', margin: '0 auto', padding: '20px' }}>
//       <h2>Forgot Password</h2>
      
//       {isSuccess ? (
//         <div>
//           <div style={{ backgroundColor: '#e8f5e9', padding: '15px', borderRadius: '5px', marginBottom: '20px' }}>
//             <p>{message}</p>
//           </div>
//           <p>
//             <Link to="/" style={{ textDecoration: 'none', color: '#1976d2' }}>Return to Login</Link>
//           </p>
//         </div>
//       ) : (
//         <>
//           <p>Enter your email address to receive a password reset link.</p>
//           <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               placeholder="Enter your email address"
//               required
//               style={{ padding: '12px', borderRadius: '4px', border: '1px solid #ddd' }}
//             />
//             <button 
//               type="submit" 
//               disabled={isLoading} 
//               style={{ 
//                 padding: '12px', 
//                 cursor: isLoading ? 'default' : 'pointer',
//                 backgroundColor: '#333366',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '4px',
//                 fontWeight: 'bold'
//               }}
//             >
//               {isLoading ? 'Sending...' : 'Send Reset Link'}
//             </button>
//           </form>
//           {message && <p style={{ color: 'red' }}>{message}</p>}
//           <p style={{ marginTop: '20px' }}>
//             Remember your password? <Link to="/" style={{ textDecoration: 'none', color: '#1976d2' }}>Log in</Link>
//           </p>
//         </>
//       )}
//     </div>
//   );
// };

// export default ForgotPassword;
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      
      const response = await fetch(`${apiUrl}/auth/reset-password-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setIsSuccess(true);
        setMessage(data.message || 'If an account exists with this email, a reset link will be sent.');
      } else {
        setMessage(data.message || 'An error occurred. Please try again.');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
    }
    
    setIsLoading(false);
  };

  return (
    <div style={{ 
      maxWidth: '500px', 
      margin: '0 auto', 
      padding: '20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      background: 'var(--bg-base)',
      color: 'var(--text-primary)'
    }}>
      <h2 style={{ 
        fontSize: '24px', 
        fontWeight: 'bold', 
        marginBottom: '16px', 
        color: 'var(--text-primary)'
      }}>
        Forgot Password
      </h2>
      
      {isSuccess ? (
        <>
          <div style={{ 
            backgroundColor: 'var(--bg-surface)', 
            padding: '16px', 
            borderRadius: '8px', 
            marginBottom: '20px',
            border: `1px solid var(--card-border)`,
            color: 'var(--text-secondary)'
          }}>
            <p style={{ margin: '0' }}>{message}</p>
          </div>
          <Link 
            to="/" 
            style={{ 
              color: '#676DFF', 
              textDecoration: 'none', 
              fontWeight: '500'
            }}
          >
            Return to Login
          </Link>
        </>
      ) : (
        <>
          <p style={{ marginBottom: '20px', color: 'var(--text-subtle)' }}>
            Enter your email address to receive a password reset link.
          </p>
          
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
                style={{ 
                  width: '100%', 
                  padding: '12px', 
                  fontSize: '16px',
                  border: `1px solid var(--border-subtle)`, 
                  borderRadius: '6px',
                  boxSizing: 'border-box',
                  background: 'var(--bg-surface)',
                  color: 'var(--text-primary)'
                }}
              />
            </div>
            
            <button 
              type="submit" 
              disabled={isLoading} 
              style={{ 
                width: '100%',
                backgroundColor: '#676DFF', 
                color: 'var(--text-primary)',
                padding: '14px',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '500',
                cursor: isLoading ? 'default' : 'pointer',
                opacity: isLoading ? 0.7 : 1
              }}
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </button>
            
            {message && !isSuccess && (
              <p style={{ color: '#EF4444', marginTop: '10px' }}>{message}</p>
            )}
            
            <p style={{ 
              marginTop: '20px', 
              textAlign: 'center',
              color: 'var(--text-subtle)'
            }}>
              Remember your password? {' '}
              <Link 
                to="/" 
                style={{ 
                  color: '#676DFF', 
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
              >
                Log in
              </Link>
            </p>
          </form>
        </>
      )}
    </div>
  );
};

export default ForgotPassword;